import React from "react";
import { FrameContext } from "../contexts/FrameContext";
import languageHelpers from "../helpers/languageHelpers";

const useTranslations = () => {
    const {companyId, brandId, settings} = React.useContext(FrameContext);

    let lang = settings && settings.lang ? settings.lang : "en";
    let content = languageHelpers.getTranslation(lang);

    //Ferragamo Customizations
    //Dev2 = "aVAf7FRVZNRnunuMY3yT"
    if (companyId === "jggOmcmcFpyvCx2Hoedv") {
        content.confirmAppointment.email = null;
        content.confirmAppointment.email2 = null;
        content.confirmAppointment.header = null;

        if (lang === "en") {
            content.common.scheduleAppointmentHeader = "Request an appointment";
            content.confirmAppointment.confirm = "Thank you for your request, please check your email box for our confirmation email";
        }

        if (lang === "it") {
            content.common.scheduleAppointmentHeader = "Prenota un appuntamento";
            content.confirmAppointment.confirm = "Grazie per la prenotazione. Riceverà a breve una mail di conferma del suo appuntamento";
        }
    }

    //YSL
    //Staging: 2Sl7FktrxakJfL8YKlSM - 7bZ5xzci7kFpXHK7N04X
    //Prod - US5: HDqlzaqP0mTEkfsVUwiZ - 366yiWv0sENwahfCWEkG
    //Prod - EU3: i0p7KeyULsMc5odK4Q1R - O585W7YcZiQCyWW0z77C
    if ((companyId === "2Sl7FktrxakJfL8YKlSM" && brandId && brandId === "7bZ5xzci7kFpXHK7N04X")
        || (companyId && companyId === "V9hdGeKzK3qPcGeriuYs" && brandId && brandId === "wRKx6hgMHAnWmLSMn65M")
        || (companyId === "HDqlzaqP0mTEkfsVUwiZ" && brandId && brandId === "366yiWv0sENwahfCWEkG")
        || (companyId === "i0p7KeyULsMc5odK4Q1R" && brandId && brandId === "O585W7YcZiQCyWW0z77C")) {
        content.common.scheduleAppointmentHeader = "Book an appointment";
        content.confirmAppointment.header = "Your virtual appointment is confirmed.";
        content.confirmAppointment.confirm = "It's scheduled with {name} on :";
        content.confirmAppointment.email = "You will receive your virtual confirmation as well as your appointment link via e-mail with the instructions to connect.";
        content.confirmAppointment.email2 = null;
    }

    //YSL - German
    //Staging: 2Sl7FktrxakJfL8YKlSM - z4KKbD09wP7PbcLeM0Wk
    //Prod - EU3: i0p7KeyULsMc5odK4Q1R - mfWDo6fsb4FMKqfXGNpg
    if ((companyId === "2Sl7FktrxakJfL8YKlSM" && brandId && brandId === "z4KKbD09wP7PbcLeM0Wk")
    || (companyId === "2Sl7FktrxakJfL8YKlSM" && brandId && brandId === "mfWDo6fsb4FMKqfXGNpg")) {
        content.common.scheduleAppointmentHeader = "Termin Vereinbaren";
        content.confirmAppointment.header = " Ihr virtueller Termin ist bestätigt.";
        content.confirmAppointment.confirm = "Es ist gebucht mit {name} am :";
        content.confirmAppointment.email = "Sie werden Ihre Terminbestätigung per Email mit einer Anleitung zur Verbindung erhalten.";
        content.confirmAppointment.email2 = null;
        content.common.closeWindow = "Fenster schließen";
    }

    //AMQ
    //Staging: 2Sl7FktrxakJfL8YKlSM - geMkgyzekNRWCkAdxbJE
    //
    if (companyId && companyId === "2Sl7FktrxakJfL8YKlSM" && brandId && brandId === "geMkgyzekNRWCkAdxbJE") {
        content.confirmAppointment.email = "We have sent you an email with the appointment confirmation.";
    }

    //Helzberg
    //Staging: 0Z4EVGu28FraN8RxnyXx
    // PROD: 
    if (companyId && (companyId === "0Z4EVGu28FraN8RxnyXx"
        || companyId === "WescFivhhS2UFUgo6ntD")) {
        content.common.scheduleAppointmentHeader = "schedule";
        content.common.scheduleAppointmentHeader2 = "virtual appointment";
        content.confirmAppointment.header = "you're all set!"
        content.confirmAppointment.confirm = "Woo-hoo! You're officially scheduled for a virtual appointment with {name}.";
        content.confirmAppointment.email = "We've emailed you the appointment link along with instructions on how to connect at your scheduled time."
        content.confirmAppointment.email2 = null;
    }

    return content;
}

export default useTranslations;